import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, catchError, take } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../models/ApiResponse';
import { WorkFlowProjectPaginated } from '../../models/Workflow/WorkFlowProjectPaginated';
import { PagedSearchOptions } from '../../models/Workflow/PagedSearchOptions';

@Injectable({
  providedIn: 'root',
})
export class WorkflowService {
  private readonly http = inject(HttpClient);
  private URL_API = environment.apiUrl;

  getWorkFlowProjectsPaged(options: PagedSearchOptions): Observable<ApiResponse<WorkFlowProjectPaginated> | null> {
    let params = new HttpParams()
      .set('page', options.page.toString())
      .set('pageSize', options.pageSize.toString());

    if (options.sort) {
      params = params.set('sort', options.sort);
    }
    if (options.sortDir) {
      params = params.set('sortDir', options.sortDir);
    }
    if (options.searchField) {
      params = params.set('searchField', options.searchField);
    }
    if (options.searchFieldValue) {
      params = params.set('searchFieldValue', options.searchFieldValue);
    }
    if (options.defaultSearchFields?.length) {
      options.defaultSearchFields.forEach(field => {
        params = params.append('defaultSearchFields', field);
      });
    }
    if (options.includedClosingFields?.length) {
      options.includedClosingFields.forEach(field => {
        params = params.append('includedClosingFields', field.toString());
      });
    }
    return this.http
      .get<ApiResponse<WorkFlowProjectPaginated>>(`${this.URL_API}/api/WorkFlowProject/Paged`, { params })
      .pipe(
        take(1),
        catchError(() => of(null))
      );
  }
}
